<template>
  <div class="tw-px-6 tw-pt-8">
    <div class="tw-grid tw-grid-cols-1 tw-gap-6">
      <span
        class="tw-text-body-sm tw-cursor-pointer tw-font-medium"
        @click="handleScroll('mediasAndPros')"
        >{{ $t('nav.mobile.loggedOut.ourMediasAndPros') }}</span
      >
      <span
        class="tw-text-body-sm tw-cursor-pointer tw-font-medium"
        @click="handleScroll('howitworks')"
        >{{ $t('nav.mobile.loggedOut.howItWorks') }}</span
      >
      <span
        class="tw-text-body-sm tw-cursor-pointer tw-font-medium"
        @click="handleScroll('landingPricing')"
        >{{ $t('nav.mobile.loggedOut.pricing') }}</span
      >
      <a
        :href="blogLink"
        target="_blank"
        class="tw-text-body-sm tw-cursor-pointer tw-font-medium"
        @click="handleBlogClick"
      >
        {{ $t('nav.mobile.loggedOut.blog') }}
      </a>
      <div class="tw-relative tw-h-px tw-w-full tw-bg-gray-300"></div>
      <NuxtLinkLocale
        v-if="!isOnCmsLandingPage"
        to="/influencer/signup/"
        class="tw-text-body-sm tw-font-medium"
        @click="handleBecomeAProClick"
        >{{ $t('nav.mobile.loggedOut.becomeAPro') }}
      </NuxtLinkLocale>
      <span
        class="tw-text-body-sm tw-cursor-pointer tw-font-medium tw-text-orange-500"
        @click="handleSigninClick"
        >{{ $t('common.signIn') }}</span
      >
      <BtnOrange small @click="handleSignupClick">
        <span class="btnText">{{ $t('common.signUp') }}</span>
      </BtnOrange>
      <div class="tw-relative tw-h-px tw-w-full tw-bg-gray-300"></div>
      <SwitchLang v-if="!isOnCmsLandingPage" class="tw-mb-4 sm:tw-mb-0" />
    </div>
  </div>
</template>

<script lang="ts">
import { mapActions } from 'pinia'
import { defineComponent } from 'vue'

import SwitchLang from '~/components/nav/switchLang.vue'
import { BtnOrange } from '~/components/ui/Buttons/'

import eventsMixin from '~/mixins/events'

import { useIsOnCmsLandingPage } from '~/composables/useIsOnCMSLandingPage'

import { useBandSignupStore } from '~/stores/bandSignup'
import { useLoginStore } from '~/stores/login'

import softScrollToDomId from '~/helpers/shared/softScrollToDomId'

export default defineComponent({
  components: {
    BtnOrange,
    SwitchLang,
  },
  mixins: [eventsMixin],
  emits: ['close'],
  setup() {
    const { isOnCmsLandingPage } = useIsOnCmsLandingPage()

    return {
      isOnCmsLandingPage,
    }
  },
  data() {
    return {
      blogLink: 'https://blog.groover.co',
    }
  },
  methods: {
    ...mapActions(useLoginStore, { LOGIN_SET_DISPLAY: 'SET_DISPLAY' }),
    ...mapActions(useBandSignupStore, {
      BAND_SIGNUP_SET_DISPLAY: 'SET_DISPLAY',
    }),
    scrollToDomId(id: string): void {
      this.$emit('close')
      window.setTimeout(() => {
        softScrollToDomId(id)
      }, 350)
    },
    handleScroll(domId: string): void {
      this.scrollToDomId(domId)
      this.trackEvent({
        category: 'Navbar',
        action: 'Scroll to section',
        target: domId,
      })
    },
    handleBlogClick(): void {
      this.trackEvent({
        category: 'Navbar',
        action: 'Open blog page',
        link: this.blogLink,
      })
    },
    handleBecomeAProClick(): void {
      this.$emit('close')
      this.trackEvent({
        category: 'Navbar',
        action: 'Open influencer signup',
      })
    },
    handleSigninClick(): void {
      this.LOGIN_SET_DISPLAY(true)
      this.$emit('close')
      this.trackEvent({
        category: 'Navbar',
        action: 'Open sign in dialog',
        label: 'navCTA',
      })
    },
    handleSignupClick(): void {
      this.BAND_SIGNUP_SET_DISPLAY(true)
      this.$emit('close')
      this.trackEvent({
        category: 'Navbar',
        action: 'Open sign up dialog',
        label: 'navCTA',
      })
    },
  },
})
</script>
